import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav.jsx';

export default function Layout() {
  return (
    <div style={{ display:'flex', flexDirection:'column', minHeight:'100vh', background:'var(--n50)' }}>
      <main style={{ flex:1, display:'flex', flexDirection:'column' }}>
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
